module.exports = __webpack_public_path__ + "resources/img/img_maxgauge3.170ac3bac9351c038da61879250f47aa.png";